import React from "react";
import { Stack, Divider } from "@mui/material";
import { Container } from "../Styled/HomeStyled";
import Header from "../Header";
import HomeBanner from "./HomeBanner";
import QuickMenu from "./QuickMenu";
import DeviceSelector from "./DeviceSelector";
import HomeCalendar from "./HomeCalendar";
import HomeStats from "./HomeStats";
import Conversation from "../../Conversation/Conversation";
import Report from "../../Report/Report";
import Pronunciation from "../../Pronunciation/Pronunciation";
import { c } from "../../../theme/colorUtils";

const TabContainer = ({ tabValue, deviceSelectorOpen, setDeviceSelectorOpen }) => {
  const renderTabContent = () => {
    switch (tabValue) {
      case "board":
        return (
          <>
            <Header />
            <Container>
              <HomeBanner /> {/* 배너 영역 */}
              <DeviceSelector deviceSelectorOpen={deviceSelectorOpen} setDeviceSelectorOpen={setDeviceSelectorOpen} /> {/* 디바이스 선택 */}
              <QuickMenu />
              <Stack gap={1} py={4}>
                <HomeCalendar /> {/* 달력 */}
                <HomeStats /> {/* 통계 데이터 */}
              </Stack>

            </Container>
          </>
        );
      case "conversation":
        return <Conversation />;
      case "report":
        return <Report />;
      case "pronunciation":
        return <Pronunciation />;
      default:
        return null;
    }
  };

  return renderTabContent();
};

export default TabContainer;
